<template>
  <div>
    <BaseTitle :title="$t('content.course_list')" />
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.course_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div v-if="permissionButton('ROLE_COURSE_MANAGEMENT_CREATE') || permissionButton('ROLE_COURSE_MANAGEMENT_LITE_CREATE')">
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" v-if="user.roleId !== 6" @click="add">{{ $t('add') }}</v-btn>
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.courseId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="vocabulary" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content"> {{ item.name }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3"> {{ $t('form.desc') }}: </span>
                    <td v-if="item.description.length > 80">{{ item.description.substring(0, 85) + '...' }}</td>
                    <td v-if="item.description.length < 80">{{ item.description.substring(0, 85) }}</td>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1" v-if="user.roleId === 2 || user.roleId === 4">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissionButton('ROLE_COURSE_MANAGEMENT_UPDATE') || permissionButton('ROLE_COURSE_MANAGEMENT_LITE_UPDATE')">
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <div
                        v-if="
                          (permissionButton('ROLE_COURSE_MANAGEMENT_DELETE') && item.used == false && item.deleteable === false) ||
                            (permissionButton('ROLE_COURSE_MANAGEMENT_LITE_DELETE') && item.deleteable === false)
                        "
                      >
                        <v-list-item>
                          <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
        <!-- <v-data-table
          :headers="tableHeader"
          :items="items"
          :loading="table.loading"
          :server-items-length="items.length"
          :options.sync="table.options"
          hide-default-footer
          class="table-custom"
        >
          <template #top>
            <table-header @fetch="getData">
              <template #left>
                <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="add">{{ $t('add') }}</v-btn>
              </template>
            </table-header>
          </template>
          <template #item.description="{ item }">
            <td v-if="item.description.length > 80">{{ item.description.substring(0, 85) + '...' }}</td>
            <td v-if="item.description.length < 80">{{ item.description.substring(0, 85) }}</td>
          </template>
          <template #item.actions="{ item }">
            <v-btn text @click="onDeleteItem(item)" v-if="item.used == false" class="mr-1"><svg-icon icon="delete" class="red--text"/></v-btn>
            <v-btn text @click="onPopUp()" v-if="item.used == true" class="mr-1"><svg-icon icon="delete" class="grey--text"/></v-btn>
            <v-btn text @click="editItem(item)"><svg-icon icon="edit" class="primary--text"/></v-btn>
          </template>
          <template #no-data>
            <NoData />
          </template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Success -->
    <v-dialog v-model="dialogPopUpGuide" persistent max-width="800">
      <v-card>
        <v-card-title class="headline secondary white--text">{{ $t('content.modal_guide') }} </v-card-title>
        <v-stepper v-model="e1" class="pa-5">
          <v-stepper-header class="elevation-0">
            <v-stepper-step :complete="e1 > 1" step="1">
              {{ $t('content.welcome') }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="e1 > 2" step="2">
              {{ $t('content.course_create') }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="e1 > 3" step="3">
              {{ $t('content.class_create') }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step step="4">
              {{ $t('content.modal_guide7') }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="d-flex justify-center pa-5">
                <svg-icon icon="cerdas-guide" width="150" height="150" />
              </div>
              <v-card-title class="headline d-flex justify-center guide-title mb-4">{{ $t('content.modal_guide1') }}!</v-card-title>
              <v-card-text class="d-flex justify-center guide-card-text-content">{{ $t('content.modal_guide2') }}.</v-card-text>
              <v-card-text class="d-flex justify-space-between">
                <v-checkbox v-model="checkboxGuide" :label="`${$t('content.modal_guide8')} `" />
                <v-btn width="248" color="primary" class="btn-primary-custom mt-4" @click="checkboxGuide ? storeGuide() : (e1 = 2)">
                  {{ $t(checkboxGuide ? 'content.modal_guide7' : 'content.continue') }}
                </v-btn>
              </v-card-text>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card-text
                ><svg-icon icon="vocabulary" width="20" height="20" class="primary--text mr-3 mt-2" />
                <strong class="guide-card-text">{{ $t('content.modal_guide5') }}</strong>
              </v-card-text>
              <v-card-text>
                <form-group :name="$t('form.name')">
                  <v-text-field disabled value="Ipa" :label="$t('form.name')" />
                </form-group>
                <form-group :name="$t('form.desc')">
                  <v-textarea disabled value="This is a IPA Course for the 2020-2021 school year" :label="$t('form.desc')" />
                </form-group>
              </v-card-text>
              <v-card-text class="guide-card-text-content">{{ $t('content.modal_guide6') }}.</v-card-text>
              <v-card-text class="d-flex justify-space-between">
                <v-checkbox v-model="checkboxGuide" :label="`${$t('content.modal_guide8')} `" />
                <v-btn width="248" color="primary" class="btn-primary-custom mt-4" @click="checkboxGuide ? storeGuide() : (e1 = 3)">
                  {{ $t(checkboxGuide ? 'content.modal_guide7' : 'content.continue') }}
                </v-btn>
              </v-card-text>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card-text>
                <svg-icon icon="desktop" width="20" height="20" class="primary--text mr-3 mt-2" />
                <strong class="guide-card-text">{{ $t('content.modal_guide3') }}</strong>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <form-group :name="$t('table.grade')">
                      <v-text-field value="VII" disabled :label="$t('table.grade')" />
                    </form-group>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <form-group :name="$t('content.classroom')">
                      <v-text-field value="A" disabled :label="$t('content.classroom')" />
                    </form-group>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <form-group :name="$t('form.schoolyear')">
                      <v-text-field value="2020 - 2021" disabled :label="$t('form.schoolyear')" />
                    </form-group>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <form-group :name="$t('form.status')">
                      <v-text-field value="Active" disabled :label="$t('form.status')" />
                    </form-group>
                  </v-col>
                  <v-col cols="12" md="12" class="py-0">
                    <form-group :name="$t('menu.course')">
                      <v-text-field value="IPA" disabled :label="$t('menu.course')" />
                    </form-group>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text class="d-flex justify-center guide-card-text-content">{{ $t('content.modal_guide4') }}.</v-card-text>
              <v-card-text class="d-flex justify-space-between">
                <v-checkbox v-model="checkboxGuide" :label="`${$t('content.modal_guide8')} `" />
                <v-btn width="248" color="primary" class="btn-primary-custom mt-4" @click="checkboxGuide ? storeGuide() : (e1 = 4)">
                  {{ $t(checkboxGuide ? 'content.modal_guide7' : 'content.continue') }}
                </v-btn>
              </v-card-text>
            </v-stepper-content>
            <v-stepper-content step="4">
              <div class="d-flex justify-center pa-5">
                <svg-icon icon="cerdas_guide_1" width="200" height="200" />
              </div>
              <v-card-title class="headline d-flex justify-center guide-title mb-4"> {{ $t('content.modal_guide9') }}</v-card-title>
              <v-card-text class="d-flex justify-center guide-card-text-content">{{ $t('content.modal_guide10') }}. </v-card-text>
              <v-card-text class="d-flex justify-space-between">
                <v-checkbox v-model="checkboxGuide" :label="`${$t('content.modal_guide8')} `" />
                <v-btn width="248" color="primary" class="btn-primary-custom mt-4" @click="storeGuide">
                  {{ $t('content.modal_guide7') }}
                </v-btn>
              </v-card-text>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';

export default {
  name: 'CourseIndex',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'CourseSchool/items',
      user: 'Auth/user',
      guidePopUp: 'Auth/guidePopUp',
      permission: 'Auth/permission'
    }),
    tableHeader() {
      return [
        { text: this.$t('form.name'), value: 'name' },
        { text: this.$t('form.desc'), value: 'description' },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 180 }
      ];
    }
  },
  data: () => ({
    e1: 1,
    dialogDelete: false,
    currentItem: null,
    dialogPopUpGuide: false,
    checkboxGuide: false,
    listData: [],
    search: '',
    loadingLoad: false,
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    onPopUp() {
      this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_course_index') });
    },
    getData() {
      // this.table.loading = true;
      // this.$store.dispatch('CourseSchool/fetchList', { ...this.form, ...this.table.options }).finally(() => (this.table.loading = false));
      this.loadingLoad = true;
      this.$store
        .dispatch(`CourseSchool/${this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null ? 'fetchList' : 'fetchListLite'}`, {
          search: this.search
        })
        .then(data => (this.listData = data))
        .finally(() => (this.loadingLoad = false));
    },
    getDataGuide() {
      this.loading = true;
      this.$store
        .dispatch('Class/guideCheck')
        .then(res => {
          if (res.guideShown === false && this.guidePopUp === true) {
            this.dialogPopUpGuide = true;
            this.checkboxGuide = res.guideShown;
          }
        })
        .finally(() => (this.loading = false));
    },
    storeGuide() {
      this.loading = true;
      this.$store.dispatch('Class/guideCheckLoad', { guideShown: this.checkboxGuide }).finally(() => {
        this.loading = false;
        this.$store.commit('Auth/SET_GUIDE_POP', { guidePopUp: false });
        // this.getDataGuide();
        this.dialogPopUpGuide = false;
      });
    },
    add() {
      this.$router.push({ name: 'CreateCourse' });
    },
    editItem({ courseId: id }) {
      this.$router.push({ name: 'EditCourse', params: { id } });
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;
      this.table.loading = true;
      this.$store
        .dispatch(`CourseSchool/${this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null ? 'destroy' : 'destroyLite'}`, this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
    }
  },
  created() {
    this.$store.commit('table/RESET_PAGEABLE');
    this.getData();
    if (this.user.cerdasTypeId === 1) {
      this.getDataGuide();
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll {
  overflow: scroll;
  overflow-x: hidden;
  height: 20em;
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.guide-card-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 18px;
  line-height: 22px;
  text-align: left;
}

.guide-card-text-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 24px;
  text-align: left;
}

.guide-title {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 18px;
  line-height: 22px;
  text-align: left;
}
</style>
